export default "__VITE_ASSET__3af83c92__"